import apiEwallet from '@/api/vo/ewallet';

const defaultState = () => ({
	listEwalletLog: [],
	ewalletLogPagination: '',
	ewalletSummary: {},
	listHistoriEwallet: [],
	historiEwalletPagination: '',
	responseSuccess: {},
	autocompleteMitra: [],
	errorValidation: []
});

const state = defaultState();

const getters = {

};

const mutations = {

	setEwalletLog(state, data) {
		state.listEwalletLog = data.data;
		state.ewalletLogPagination = data.pagination;
	},
	setEwalletSummary(state, data) {
		state.ewalletSummary = data.data;
	},
	setHistoriEwallet(state, data) {
		state.listHistoriEwallet = data.data;
		state.historiEwalletPagination = data.pagination;
	},
	setSuccessTransaction(state, data) {
		state.responseSuccess = data.data
	},
	setErrorValidation(state, data) {
		state.errorValidation = data
	},
	setAutocompleteMitra(state, data) {
		state.autocompleteMitra = data.data
	}
};

const actions = {

	getEwalletLogAll({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiEwallet.getEwalletLogAll(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setEwalletLog', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setEwalletLog', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getEwalletLogIn({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiEwallet.getEwalletLogIn(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setEwalletLog', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setEwalletLog', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getEwalletLogOut({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiEwallet.getEwalletLogOut(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setEwalletLog', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setEwalletLog', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getEwalletSummary({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiEwallet.getEwalletSummary(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setEwalletSummary', data.results);
					resolve(data.results)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setEwalletSummary', {});
				reject()
			});
		});
	},

	getHistoriTransfer({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiEwallet.getHistoriTransfer(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoriEwallet', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoriEwallet', { data: [], pagination: {} });
				reject()
			});
		});
	},

	transferEwallet({ dispatch, commit }, value) {
		return new Promise((resolve, reject) => {
			apiEwallet.transferEwallet(value).then( results => {
				const data = results.data;
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuccessTransaction', data.results );
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(error => {
				dispatch("errorHandler", error)
				reject()
			})
		});
	},

	getAutocompleteMitra({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiEwallet.getAutocompleteMitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setAutocompleteMitra', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setAutocompleteMitra', {});
				reject()
			});
		});
	},

	checkPinPramitra({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiEwallet.checkPinPramitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					resolve(data.results)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch((err) => {
				dispatch("errorHandler", err)
				reject()
			});
		});
	},

	checkPinMitra({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiEwallet.checkPinMitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					resolve(data.results)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch((err) => {
				dispatch("errorHandler", err)
				reject()
			});
		});
	},

	setPinMitra({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiEwallet.setPinMitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					resolve()
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(error => {
				dispatch("errorHandler", error)
				reject()
			})
		});
	},

	setPinPramitra({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiEwallet.setPinPramitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					resolve()
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(error => {
				dispatch("errorHandler", error)
				reject()
			})
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};